// extracted by mini-css-extract-plugin
export default {"itemContainer":"edit-basket-item-overlay_itemContainer__d4d74"};